/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
const DHL_LIST_VARIANTS = {
    BULLET: "bullet",
    CHECK: "check",
    NUMBER: "number",
};
const DHL_LIST = {
    VARIANT: DHL_LIST_VARIANTS,
};

export { DHL_LIST as D };

//# sourceMappingURL=constants-9ad7f0a4.js.map